import React from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import VisibilityIcon from '@mui/icons-material/Visibility';

const DynamicTable = ({ headers, data, action }) => {
  const navigate = useNavigate();

  return (
    <div className="container-fluid">
      <div
        className="container-fluid text-center mt-3 border rounded-md px-0 pb-3"
        style={{ backgroundColor: "white" }}
      >
        <div className="table-responsive rounded-md" style={{ maxHeight: "400px" }}>
          <table className="table">
            <thead
              className="position-sticky top-0"
              style={{ backgroundColor: "#e2e8f0"}}
            >
              <tr>
                {headers.map((header, index) => (
                  <th key={index} className="text-start text-blue-900 pl-3">{header.label}</th>
                ))}
                <th className="text-blue-900">Action</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index} className="bg-light">
                    {headers.map((header, idx) => (
                      <td key={idx}>
                        <h6 className="mt-1 ml-1">
                          {header.key === "created_at"
                            ? moment(item[header.key]).format("DD/MM/YYYY")
                            : item[header.key] || "--NA--"}
                        </h6>
                      </td>
                    ))}
                    <td className="text-center">
                      <button
                        className="btn btn-outline-success p-0 px-1"
                        onClick={() => action(navigate, item.id)}
                      >
                        <VisibilityIcon />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={headers.length + 1} className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DynamicTable;
